/**
 * Helper for variants that accept {@code image: string | ReactNode}.
 *
 * <ul>
 *   <li>String URL → renders an absolute-positioned {@code <img>} that
 *       fills the parent (object-fit: cover). The parent's
 *       {@code aspectRatio} and {@code overflow: hidden} control the
 *       crop.</li>
 *   <li>ReactNode → rendered as-is.</li>
 *   <li>Undefined → renders nothing.</li>
 * </ul>
 */
import type { ReactNode } from 'react';
import { resizeImageUrl } from '../_shared/resizeImageUrl';

export function CourseCardImage({ image, alt = '' }: { image?: string | ReactNode; alt?: string }) {
  if (image == null) return null;
  if (typeof image === 'string') {
    return (
      <img
        src={resizeImageUrl(image, '680x0')}
        alt={alt}
        loading="lazy"
        decoding="async"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    );
  }
  return <>{image}</>;
}
